export default "__VITE_ASSET__BbuYwpL3__"